import { RESERVED_SLUGS } from "@scrile/contracts";

/** Адрес студии приходит из сборки, но не должен стать исполняемой или protocol-relative ссылкой. */
export function studioAddress(raw = "/studio/"): string {
  const value = raw.trim();
  if (!value || /[\\\u0000-\u001f]/.test(value) || value.startsWith("//")) return "/studio/";
  try {
    const url = new URL(value, "https://base.invalid");
    if (url.username || url.password || url.protocol !== "https:") return "/studio/";
    if (value.startsWith("/")) return `${url.pathname.replace(/\/+$/, "")}/`;
    if (!value.startsWith("https://")) return "/studio/";
    return `${url.origin}${url.pathname.replace(/\/+$/, "")}/`;
  } catch { return "/studio/"; }
}

/** Только точное имя базового домена — ошибки героя не превращаются в лендинг. */
export function isPlatformHost(hostname: string, baseDomain: string, rootHeroSlug = ""): boolean {
  const normalize = (value: string) => value.trim().toLowerCase().replace(/\.$/, "");
  const base = normalize(baseDomain);
  return rootHeroSlug.trim() === "" && base.length > 0 && normalize(hostname) === base;
}

/** Вводится только slug: произвольные адреса и зарезервированные хосты не открываем. */
export function heroAddress(input: string, baseDomain: string): string | null {
  const slug = input.trim().toLowerCase();
  const base = baseDomain.trim().toLowerCase().replace(/\.$/, "");
  if (!/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/.test(slug)) return null;
  if ((RESERVED_SLUGS as readonly string[]).includes(slug)) return null;
  if (!/^[a-z0-9.-]+$/.test(base) || base.includes("..")) return null;
  return `https://${slug}.${base}/`;
}
